import { createContext } from "react";
import { noop } from "../_util/noop";

interface MenuContextValue {
  collapsed: boolean;
  setMobileCollapsed: (mobileCollapsed: boolean) => void;
}

export const MenuContext = createContext<MenuContextValue>({
  collapsed: false,
  setMobileCollapsed: noop,
});

interface SubMenuContextValue {
  inSubMenu: boolean;
  onTagChange: (id: string, hasTag: boolean) => void;
  onSelectedChange: (id: string, selected: boolean) => void;
}

export const SubMenuContext = createContext<SubMenuContextValue>({
  inSubMenu: false,
  onTagChange: noop,
  onSelectedChange: noop,
});
